import { FormControl, FormLabel, MenuItem, Select, SelectChangeEvent, styled, Typography } from '@mui/material'
import { defaultGridListPageSize, pageSizeOptions } from '../../util/Constants';
import theme from '../../Theme';


const Dropdown = styled(Select<string>)((props) => ({
    marginTop: '4px !important',
    '&:before, &:after': {
        display: 'none'
    }
}));

interface PageSizeDropdownProps {
    selectedPageSize?: number;
    pageSizes?: number[];
    onPageSizeSelectionChange: (rowsPerPage: number) => void;
}

const PageSizeDropdown: React.FC<PageSizeDropdownProps> = (props: PageSizeDropdownProps) => {
    const { selectedPageSize = defaultGridListPageSize, pageSizes = pageSizeOptions, onPageSizeSelectionChange } = props;

    const onChange = (event: SelectChangeEvent<string>) => {
        const selectedValue = event.target.value;
        // Convert the selected value to a number and call the callback function
        const pageSize = parseInt(selectedValue, 10);
        onPageSizeSelectionChange(pageSize);
    };

    return (
        
        <FormControl size="small" sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <FormLabel sx={{ marginRight: 1 }} ><Typography variant='subtitle2' fontWeight={400} color="text.primary">Rows per page:</Typography></FormLabel>
            <Dropdown
                id="page-size-select"
                value={selectedPageSize.toString()}
                onChange={onChange}
                variant="standard"
                sx={{ 
                    '& .MuiInput-input': {
                        color: theme.palette.text.primary,
                        typography: theme.typography.subtitle2,
                        fontWeight: 400,
                    }
                }}
            >
                {pageSizes.map((size: number) => (
                    <MenuItem key={size} value={size.toString()}>
                    {size}
                    </MenuItem>
                ))}
            </Dropdown>
        </FormControl>
    )
};

export default PageSizeDropdown;